import Vue from 'vue';
import * as C from '../constants';

export default {
  [C.XML_PRODUCTS_LOAD_PENDING](state) {
    state.xmlProducts = {
      ...state.xmlProducts,
      itemsLoading: true,
      itemsError: false,
      items: [],
    };
  },
  [C.XML_PRODUCTS_LOAD_SUCCESS](state, payload) {
    state.xmlProducts = {
      ...state.xmlProducts,
      itemsLoading: false,
      itemsError: false,
      items: payload,
    };
  },
  [C.XML_PRODUCTS_LOAD_FAILURE](state) {
    state.xmlProducts = {
      ...state.xmlProducts,
      itemsLoading: false,
      itemsError: false,
      items: [],
    };
  },
  // XML Channels
  [C.XML_CHANNELS_LOAD_PENDING](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      itemsLoading: true,
      itemsError: false,
      items: [],
    };
  },
  [C.XML_CHANNELS_LOAD_SUCCESS](state, payload) {
    state.xmlChannels = {
      ...state.xmlChannels,
      itemsLoading: false,
      itemsError: false,
      items: payload,
    };
  },
  [C.XML_CHANNELS_LOAD_FAILURE](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      itemsLoading: false,
      itemsError: false,
      items: [],
    };
  },

  [C.TWENTY_BRANDS_LOAD_PENDING](state) {
    Vue.set(state, 'brands', {
      ...state.brands,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.TWENTY_BRANDS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'brands', {
      ...state.brands,
      items: payload,
      itemsLoading: false,
    });
  },

  [C.TWENTY_BRANDS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'brands', {
      ...state.brands,
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TWENTY_BRANDS_CHANGE](state, payload) {
    Vue.set(state, 'brands', {
      ...state.brands,
      selectedBrands: payload,
    });
  },

  [C.TWENTY_SALES_STATS_LOAD_PENDING](state) {
    Vue.set(state, 'salesStats', {
      ...state.salesStats,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.TWENTY_SALES_STATS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'salesStats', {
      ...state.salesStats,
      items: payload,
      itemsLoading: false,
    });
  },

  [C.TWENTY_SALES_STATS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'salesStats', {
      ...state.salesStats,
      itemsLoading: false,
      itemsError: payload,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/twenty/mutations.js